import React, { useState } from 'react';
import { onAuthStateChanged, signInWithEmailAndPassword} from 'firebase/auth'
import styled from 'styled-components'
import {firebaseAuth} from '../utils/firebase-config';
import BackgroundImage from '../components/BackgroundImage';
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header';
export default function Login() {

    const [formValues,setFormValues] = useState({
        email:"",
        password:""
    })
    const navigate =  useNavigate()
    const handleLogIn = async ()=>{
        try {
            const { email,password } = formValues;
            await signInWithEmailAndPassword(firebaseAuth,email,password);
            console.log(formValues)
        } catch (error) {
            console.log(error)
        }
    }
    onAuthStateChanged(firebaseAuth,(currentUser)=>{
        if(currentUser) navigate("/")
    })
  return (
    <Container>
       <BackgroundImage/>
       <div className="content">
        <Header/>
        <div className="form-container flex column a-center j-center">
          <div className="form flex column a-center j-center">
            <div className="title">
              <h3>Log In</h3>
            </div>
              <div className="container flex column">
               <input type="email" name="email" placeholder='abcdxyz@jkl.com' value={formValues.email} onChange={(e)=>setFormValues({...formValues,[e.target.name]:e.target.value,})} />
               <input type="password" name="password" placeholder='enter password' value={formValues.password} onChange={(e)=>setFormValues({...formValues,[e.target.name]:e.target.value,})}/>
               <button onClick={handleLogIn}>Log In</button>
               
            
            </div>
          </div>
        </div>
       </div>
    </Container>
  )
}
 const Container = styled.div`
 position: relative;
 .content{
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    height: 100vh;
    width: 100vw;
    display: grid;
    grid-template-rows:15vh 85vh;
    .form-container{
      gap: 2rem;
      height: 80vh;
      .form{
        padding: 2rem;
        background-color: #000000b0;
        width: 30vw;
        gap: 2rem;
        color: white;
        .container{
          gap: 2rem;
          input{
            padding: 0.5rem 1rem;
            width: 15rem;
          }
          button{
            padding: 0.5rem 1rem;
            background-color: #00A1FF;
            border: none;
            color: white;
            cursor: pointer;
            border-radius: 0.2rem;
            font-weight:bolder;
            font-size: 1.05rem;

          }
        }
      }

    }
 }
 `;
